var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.attrs.books)?_c('div',{staticClass:"library"},[_c('h4',{staticClass:"font-size-12"},[_vm._v("Bibliografia")]),_c('div',{staticClass:"list"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.block.attrs.books)}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }